import { FC, Children, isValidElement, cloneElement } from 'react';
import { clsx } from '@team/clsx';
import { Props } from './types';
import { getTokenClassNameByType } from './model';
import css from './style.module.css';

export const Entry: FC<Props> = ({ type, children }) =>
  Children.map(children, (child) => {
    if (isValidElement<HasClassName>(child)) {
      return cloneElement(child, {
        className: clsx(
          css.appearance,
          getTokenClassNameByType(type),
          child.props.className
        ),
      });
    }

    return child;
  });
